import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { showAlertModal } from '../../../../actions';
import FormWrapper from '../FormWrapper';
import Dialog from '../../../common/Dialog';

class CustomerForm extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      bID: '',
      name: '',
      dir: '',
      domain: '',
      public: false,
      customerEdit: false,
      showDeleteCustomerPrompt: false
    }
  }

  componentDidMount(){
    if(this.props.customer){
      // we are editing a current site
      this.setState({
        bID: this.props.customer.bID,
        customerEdit: true,
        name: this.props.customer.sName,
        dir: this.props.customer.sDir,
        domain: this.props.customer.sDomain,
        public: this.props.customer.fPublic === 0 ? false : true,
      })
    }
  }

  componentDidUpdate() {
    if(this.props.customer && this.props.customer.bID && this.props.customer.bID !== this.state.bID){
      this.setState({
        bID: this.props.customer.bID,
        customerEdit: true,
        name: this.props.customer.sName,
        dir: this.props.customer.sDir,
        domain: this.props.customer.sDomain,
        public: this.props.customer.fPublic === 0 ? false : true,
      })
    }
  };

  handleChange = (e, type) => {
    if(type === 'public'){
      e.persist();
      this.setState({ public: e.target.checked });
      return;
    };

    this.setState({ [type]: e.target.value })
  }

  onSubmit = async() => {
    if (this.state.name.trim() === '' || this.state.dir.trim() === '' || this.state.domain.trim() === '') {
      this.props.showAlertModal(['WARNING', 'Please fill in all details.']);
      return
    }

    const reqBody = {
      "id": this.state.customerEdit ? this.props.customer.bID : null,
      "name": this.state.name,
      "dir": this.state.dir,
      "domain": this.state.domain,
      "public": this.state.public ? 1 : 0
    };

    await axios({
      method: 'post',
      url: this.props.cloudAPI + 've/customer?device=' + this.props.deviceList[0],
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + this.props.token
      },
      withCredentials: true,
      data: reqBody
    }).then(response => {
      // insert returns new id in response.data.data[0], update returns null in response.data.data[0]
      this.props.showAlertModal(['SUCCESS', 'Customer details successfully saved.'])

      this.props.updateData('customer', {
        bID: (this.state.customerEdit) ? this.props.customer.bID : response.data.data[0],
        sName: this.state.name,
        sDir: this.state.dir,
        sDomain: this.state.domain,
        fPublic: (this.state.public === true) ? 1 : 0,
      });

      !this.state.customerEdit && this.props.closeForm()

    }).catch(error => {
      console.log(error)
      this.props.showAlertModal(['ERROR', 'Unable to save customer details.'])
    })
  };

  undoEdit = () => {
    this.setState({
      bID: this.props.customer.bID,
      customerEdit: true,
      name: this.props.customer.sName,
      dir: this.props.customer.sDir,
      domain: this.props.customer.sDomain,
      public: this.props.customer.fPublic === 0 ? false : true,
    });
  };

  promptDeleteCustomer = () => {
    this.setState({ showDeleteCustomerPrompt: true });
  };

  deleteCustomer = async (customer) => {
    const reqBody = {
      "id": this.props.customer.bID,
      "del": 1,
    };

    await axios({
      method: 'post',
      url: this.props.cloudAPI + `ve/customer?device=` + this.props.deviceList[0],
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + this.props.token
      },
      withCredentials: true,
      data: reqBody

    }).then(response => {
      this.props.showAlertModal(['SUCCESS', 'Customer successfully deleted.'])
      this.props.updateData('customer', {}, true)
      this.props.closeForm();

    }).catch(error => {
      console.log(error)
      this.props.showAlertModal(['ERROR', 'Unable to delete customer.'])
      this.setState({ showDeleteCustomerPrompt: false })
    })
  }

  onBlur = (e) => {
    // edit
    if (this.props.customer) {
      const pub = this.props.customer.fPublic === 0 ? false : true

      if ((this.state.name !== this.props.customer.sName)
        || (this.state.dir !== this.props.customer.sDir)
        || (this.state.domain !== this.props.customer.sDomain)
        || (this.state.public !== pub)) {
          this.props.onBlur(e, this.onSubmit)
      }

    // new
    } else {
      if (this.state.name.trim() !== '' || this.state.dir.trim() !== '' || this.state.domain.trim() !== '' || this.state.public) {
          this.props.onBlur(e, this.onSubmit)
      }
    }
  }

  render() {
    return (
      <FormWrapper heading={this.state.customerEdit ? "Edit Customer" : "New Customer" }
                   onBlur={this.onBlur}
                   closeForm={this.props.closeForm}
                   onSubmit={this.onSubmit}
                  //  onDelete={(this.props.user.bRole === 1 && this.state.bID !== 1) && this.promptDeleteCustomer} // hide it for now until it will be decided on how to proceed
                   edit={this.state.customerEdit}
                   undoEdit={this.undoEdit} >

      <div>
        <div style={{ display: 'flex', alignITems: 'center', justifyContent: 'flex-start', marginBottom: '2vmin' }}>
          <p style={{ margin: 0, fontSize: '1.6vmin', marginRight: '1vmin', width: "14vmin" }}>Customer Name: </p>
          <input
            name="name"
            type="text"
            value={this.state.name}
            style={{ fontSize: '1.6vmin' }}
            onChange={(e) => this.handleChange(e, 'name')} />
        </div>
        <div style={{ display: 'flex', alignITems: 'center', justifyContent: 'flex-start', marginBottom: '2vmin' }}>
          <p style={{ margin: 0, fontSize: '1.6vmin', marginRight: '1vmin', width: "14vmin" }}>File Directory: </p>
          <input
              name="file directory"
              type="text"
              value={this.state.dir}
              style={{ fontSize: '1.6vmin' }}
              onChange={(e) => this.handleChange(e, 'dir')} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' , marginBottom: '2vmin'}}>
          <p style={{ margin: 0, fontSize: '1.6vmin', marginRight: '1vmin', width: "14vmin" }}>Domain: </p>
          <input
              name="domain"
              type="text"
              value={this.state.domain}
              style={{ fontSize: '1.6vmin' }}
              onChange={(e) => this.handleChange(e, 'domain')} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <p style={{ margin: 0, fontSize: '1.6vmin', marginRight: '1vmin', width: "14vmin" }}>Public: </p>
          <input
              name="public"
              type="checkbox"
              value={this.state.public}
              checked={this.state.public}
              style={{ fontSize: '1.6vmin' }}
              onChange={(e) => this.handleChange(e, 'public')} />
        </div>

      </div>

      {this.state.showDeleteCustomerPrompt &&
        <Dialog
          boxStyle={{width: '50vmin'}}
          title="WARNING"
          content={
            <div>
              <p>Are you sure you want to delete this customer?</p>
              <p>{this.props.customer.sName}</p>
              <p style={styles.dialogHighlight}>Sites associated with this customer will also be removed.</p>
              <p style={styles.dialogHighlight}>Users will no longer have access to this customer or sub sites once removed.</p>
              <p>This action cannot be undone.</p>
            </div>
          }
          buttons={[
            {label: 'Delete', onClick: () => this.deleteCustomer(this.props.customer)},
            {label: 'Cancel', onClick: () => this.setState({ showDeleteCustomerPrompt: false })},
          ]}
        />
      }

      </FormWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth
  return { user }
}
export default connect(mapStateToProps, { showAlertModal } )(CustomerForm);

const styles = {
  dialogHighlight: {
    fontWeight: 'bold',
  },
}